import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import { usePartyTypeList } from "Hooks/Options/usePartyTypeList";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  name: FieldPath<FormType>;
  control: Control<FormType, unknown, TransformedFieldValues>;
  isDisabled?: boolean;
  label?: string;
};

export const BusinessDropdown = <T extends object, V extends object>({
  control,
  name,
  label,
  isDisabled,
}: Props<T, V>) => {
  const codeListBusiness = usePartyTypeList({ onlyBusiness: true });

  return (
    <Dropdown
      codeList={codeListBusiness}
      name={name}
      control={control}
      label={label}
      disabled={isDisabled}
    />
  );
};
